import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssemblyIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 104,
	height: 106,
	viewBox: "0 0 104 106",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 3,
			y1: 2,
			x2: 3,
			y2: 103.133,
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.121 0L100.121 103.133",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 88,
			y1: 3,
			x2: 88,
			y2: 104.133,
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 3.01124L101.133 3.01124",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 102.121L103 102.121",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 16,
			y1: 3,
			x2: 16,
			y2: 104.133,
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7281 70L89.2945 70",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7281 38H88.2832",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2281 37L87.3519 6.14815",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7281 101L87.7281 70.9998",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7281 5L88.7282 37.5",
			stroke: "currentColor",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7281 72.5L90.2282 99.9999",
			stroke: "currentColor",
			strokeWidth: 6
		})
	]
});
export default SvgAssemblyIcon;
